import { createFeatureSelector } from "@ngrx/store";

import { FeatureRevisionState } from "../reducers";

export const selectFeatureRevisionState =
  createFeatureSelector<FeatureRevisionState>("featureRevisionState");
